// extracted by mini-css-extract-plugin
export var sbShowMain = "label-module--sb-show-main--3hy_o";
export var label = "label-module--label--325XX";
export var mainPrimary = "label-module--mainPrimary--q5zdX";
export var mainSecondary = "label-module--mainSecondary--1AFuf";
export var mainGradient = "label-module--mainGradient--1yD7N";
export var eduGradient = "label-module--eduGradient--27bz1";
export var workGradient = "label-module--workGradient--3Rail";
export var totaraGradient = "label-module--totaraGradient--2uOyR";